export default {
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  APP_URL: process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : process.env.APP_URL,
  ENV_NAME: process.env.NEXT_PUBLIC_ENV_NAME || process.env.ENV_NAME || 'DEVELOPMENT',
}
